import { css } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { redditColors } from '../../styles/colors'

export const footerWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

export const urlBarRow = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: redditColors.urlBarBg,
  borderRadius: '0 0 8px 8px',
  padding: '12px 16px',
  border: `1px solid ${redditColors.border}`,
  borderTop: 'none',
})

export const urlDisplay = css({
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.small,
  color: redditColors.secondaryText,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const ctaButton = css({
  backgroundColor: '#FFFFFF',
  color: redditColors.darkText,
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bold,
  padding: '6px 16px',
  borderRadius: '20px',
  border: `1px solid ${redditColors.border}`,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: redditColors.border,
  },
})

export const engagementRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginTop: '8px',
})

export const voteWrapper = css({
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
  backgroundColor: redditColors.border,
  borderRadius: '20px',
  padding: '6px 10px',
})

export const voteIcon = css({
  width: '18px',
  height: '18px',
  color: redditColors.iconGray,
  cursor: 'pointer',
  '&:hover': {
    color: redditColors.orange,
  },
})

export const voteText = css({
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bold,
  color: redditColors.darkText,
  padding: '0 4px',
})

export const actionItem = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: redditColors.border,
  borderRadius: '20px',
  padding: '6px 12px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#E0E2E4',
  },
})

export const actionIcon = css({
  width: '18px',
  height: '18px',
  color: redditColors.iconGray,
})

export const actionText = css({
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bold,
  color: redditColors.darkText,
})
